import { useCallback, useContext, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectSelectedEntityId } from "store/entity/selectors";
import { selectIllustoClipsProgress, selectIllustoProjectDetails } from "store/illustoProject/selectors";
import { setIllustoClipsProgress } from "store/illustoProject/slice";
import { selectTemplatesJobIds, selectTemplatesSkeleton } from "store/template/selectors";
import { showTemplatesSkeleton } from "store/template/slice";

import { SocketContext } from "../../../../context/socket";

const WebSocketIllustoTemplate = ({
  jobIds,
  templateSkeleton,
  showTemplatesSkeleton,
  setIllustoClipsProgress,
  illustoClipsProgress,
}) => {
  const { webhookSocket } = useContext(SocketContext);

  const updateTemplateSkeleton = useCallback(
    (data, jobId) => {
      if (!templateSkeleton || !templateSkeleton.length) return;

      const newData = [];

      templateSkeleton.forEach((skeleton) => {
        if (skeleton.jobId === jobId) {
          newData.push({
            ...skeleton,
            ...data,
          });
        } else {
          newData.push(skeleton);
        }
      });
      showTemplatesSkeleton(newData);
    },
    [templateSkeleton, showTemplatesSkeleton],
  );

  useEffect(() => {
    jobIds.forEach((jobId) => {
      webhookSocket.on(`illustoTemplateProgress_${jobId}`, (data) => {
        const projectId = data.projectId;
        const content = data;

        content.progress = data.progress / 2;
        content.templateJobId = data.jobId;
        const progressObject = {
          ...illustoClipsProgress,
        };

        progressObject[projectId] = content;
        // setIllustoClipsProgress(progressObject);
        updateTemplateSkeleton(data, jobId);
      });
    });

    return () => {
      jobIds.forEach((jobId) => {
        webhookSocket.off(`illustoTemplateProgress_${jobId}`);
      });
    };
  }, [webhookSocket, updateTemplateSkeleton, jobIds, setIllustoClipsProgress, illustoClipsProgress]);

  return null;
};

const mapStateToProps = createStructuredSelector({
  entityId: selectSelectedEntityId,
  templateSkeleton: selectTemplatesSkeleton,
  projectDetails: selectIllustoProjectDetails,
  jobIds: selectTemplatesJobIds,
  illustoClipsProgress: selectIllustoClipsProgress,
});

const mapDispatchToProps = {
  showTemplatesSkeleton,
  setIllustoClipsProgress,
};

export default connect(mapStateToProps, mapDispatchToProps)(WebSocketIllustoTemplate);
